import type { Lists } from '@brighterly/lib-core-types/lists/interfaces'

import { useListsStore } from '@stores/lists'

import { useCsRoutes } from '@composables/routes/cs-route.hook'

interface ListsApiOptions {
  onError?: (err: any) => void
}

export const useListsApi = async (options?: ListsApiOptions): Promise<Lists | null> => {
  const { $axios } = useNuxtApp()
  const url = useCsRoutes('configurations.lists')

  const listsStore = useListsStore()

  try {
    const { data } = await $axios.get(url!)

    const lists = data.data || null
    listsStore.setLists(lists)
    return lists
  } catch (err: any) {
    options?.onError?.(err)
    return null
  }
}
